import React, {Component} from 'react';
import {DropdownItem, DropdownMenu, DropdownToggle, Nav, NavItem} from 'reactstrap';
import PropTypes from 'prop-types';

import {AppHeaderDropdown} from '@coreui/react';
import Clock from 'react-live-clock';
import './Style.scss'
import * as keys from '../../const/key/Key';
import * as routeConstants from '../../const/route/Route';

import {Tooltip} from "antd";
import swal from "sweetalert";
import are_you_sure_icon from "../../assets/img/sweet/question.svg";
import Cookies from "js-cookie";
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import image from '../../assets/img/logos/md-logo.png'
import {Label} from "semantic-ui-react";

const propTypes = {
  children: PropTypes.node,
};

const defaultProps = {};

class DefaultHeader extends Component {

  onLogout = () => {
    swal({
      title: "Do you want to sign out?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Sign-out",
          value: "action",
          className: "remove-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.props.userHandler([]);
            Cookies.remove(keys.ACCESS_TOKEN);
            Cookies.remove(keys.REFRESH_TOKEN);
            localStorage.removeItem(keys.GUEST_CACHE);
            this.props.setGuestUserDetails({
              guestIsLogin:null,branchId:null,guestStatus:null,pinRequired: false
            });
            this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/login`);
            break;
          default:
        }
      });
  };


  render() {
    return (
      <React.Fragment>

          <h1 className={"logo-text"}>
            <img src={image} className={"logo-style"} alt="." style={{height: '120px'}}/>
          </h1>

        <div style={{marginLeft: '10px'}}>
            {/*<Label onClick={() => this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/dashboard`)} color='blue' horizontal*/}
                   {/*style={{cursor: 'pointer'}}>*/}
              {/*{"Check In"}*/}
            {/*</Label>*/}

            {/*<Label onClick={() => this.props.history.push(`${routeConstants.GUEST_ROUTE_PATH}/checkout`)} color='orange' horizontal*/}
                   {/*style={{cursor: 'pointer'}}>*/}
              {/*{"Check Out"}*/}
            {/*</Label>*/}
        </div>

          {/*date and time, dddd, YYYY MMMM D h:mm:ssa / YYYY M D h:mm:ssa*/}
          {/*<Clock style={{fontSize: '14px', color: 'black', marginLeft: '25px'}} format="dddd, D-MMMM-YYYY | h:mm:ss A"*/}
                 {/*ticking={true} interval={1000}/>*/}

          <Nav className="ml-auto guest-signout" navbar>
            <AppHeaderDropdown direction="down">
              <DropdownToggle nav>
              <span style={{
                fontSize: '16px',
                color: '#585858',
                fontWeight: '600',
                marginRight: '10px',
              }}>{this.props.usr_obj === undefined ? "Welcome admin" : "Welcome " + this.props.usr_obj.firstName}
                &nbsp;
                <i className="fa fa-caret-down"/>
              </span>

              </DropdownToggle>
              <DropdownMenu right style={{right: 'auto'}}>
                <DropdownItem onClick={e => this.onLogout(e)}><i className="fa fa-lock"/> Logout</DropdownItem>
              </DropdownMenu>
            </AppHeaderDropdown>
          </Nav>
        <Nav className="ml-auto guest-branch" navbar>
          <p>{this.props.guestBranchName}</p>
        </Nav>
      </React.Fragment>
    );
  }
}

DefaultHeader.propTypes = propTypes;
DefaultHeader.defaultProps = defaultProps;

const mapStateToProps = (state) => ({
  history: state.historyReducer.history,
  is_spin: state.spinnerReducer.is_spin,
  usr_obj: state.userReducer.user,

  visitor_count_list: state.reception_VisitorCountReducer.visitor_count_list,
  guestBranchName: state.guestUserReducer.guestBranchName
});

const mapDispatchToProps = (dispatch) => {
  return {

    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // guest user reducer
    setGuestUserDetails: (data) => dispatch(actionCreator.setGuestUserDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeader);
